import { default as _91color_93qoKRmYVuOmMeta } from "/app/apps/admin/pages/components/colors/[color].vue?macro=true";
import { default as createHIx7b0JszGMeta } from "/app/apps/admin/pages/components/colors/create.vue?macro=true";
import { default as colorsPvjUXiWnLOMeta } from "/app/apps/admin/pages/components/colors.vue?macro=true";
import { default as _91kind_93E4cVkgdizHMeta } from "/app/apps/admin/pages/components/kinds/[kind].vue?macro=true";
import { default as createFYKHn3ECByMeta } from "/app/apps/admin/pages/components/kinds/create.vue?macro=true";
import { default as kinds6SqKFBrsjLMeta } from "/app/apps/admin/pages/components/kinds.vue?macro=true";
import { default as _91material_936GsdJWrd0VMeta } from "/app/apps/admin/pages/components/materials/[material].vue?macro=true";
import { default as createQXxZX0Z4KNMeta } from "/app/apps/admin/pages/components/materials/create.vue?macro=true";
import { default as _91material_93Z8PwBmZeKcMeta } from "/app/apps/admin/pages/components/materials/edit/[material].vue?macro=true";
import { default as materialsG1Qugu4VzLMeta } from "/app/apps/admin/pages/components/materials.vue?macro=true";
import { default as _91size_93WHxVb2R17LMeta } from "/app/apps/admin/pages/components/sizes/[size].vue?macro=true";
import { default as createvcgcHZkMlrMeta } from "/app/apps/admin/pages/components/sizes/create.vue?macro=true";
import { default as sizesLS0kuplGChMeta } from "/app/apps/admin/pages/components/sizes.vue?macro=true";
import { default as componentsywbQkkrTCfMeta } from "/app/apps/admin/pages/components.vue?macro=true";
import { default as _91customer_93zwrrFh8XsJMeta } from "/app/apps/admin/pages/customers/[customer].vue?macro=true";
import { default as _91history_93QskcuIuy1qMeta } from "/app/apps/admin/pages/customers/customer-history/[history].vue?macro=true";
import { default as indexT3IARxwMibMeta } from "/app/apps/admin/pages/customers/index.vue?macro=true";
import { default as indexRhbCo9xKafMeta } from "/app/apps/admin/pages/index.vue?macro=true";
import { default as loginpEnoFbBpCzMeta } from "/app/apps/admin/pages/login.vue?macro=true";
import { default as _91order_93QMycmdJgBvMeta } from "/app/apps/admin/pages/orders/[order].vue?macro=true";
import { default as index0H4U70n5y3Meta } from "/app/apps/admin/pages/orders/index.vue?macro=true";
import { default as _91payment_93YOnXqfG0T3Meta } from "/app/apps/admin/pages/payments/[payment].vue?macro=true";
import { default as _91history_93WYQJeeYDnYMeta } from "/app/apps/admin/pages/payments/payment-history/[history].vue?macro=true";
import { default as _91policy_93TeDcAnYeC9Meta } from "/app/apps/admin/pages/price-policies/[policy].vue?macro=true";
import { default as createxJadlBeRDpMeta } from "/app/apps/admin/pages/price-policies/create.vue?macro=true";
import { default as _91policy_93rQUAsaKhNpMeta } from "/app/apps/admin/pages/price-policies/edit/[policy].vue?macro=true";
import { default as indexxjtXWMogASMeta } from "/app/apps/admin/pages/price-policies/index.vue?macro=true";
import { default as _91collection_93yo79fH98slMeta } from "/app/apps/admin/pages/products/collections/[collection].vue?macro=true";
import { default as createDCk24uZPCJMeta } from "/app/apps/admin/pages/products/collections/create.vue?macro=true";
import { default as collectionsLDq17kykzUMeta } from "/app/apps/admin/pages/products/collections.vue?macro=true";
import { default as _91prototype_93rSSAKfpMB3Meta } from "/app/apps/admin/pages/products/item-prototypes/[prototype].vue?macro=true";
import { default as create5TmkzhKq5EMeta } from "/app/apps/admin/pages/products/item-prototypes/create.vue?macro=true";
import { default as _91prototype_93eN4zed6ekrMeta } from "/app/apps/admin/pages/products/item-prototypes/edit/[prototype].vue?macro=true";
import { default as _91item_93a828DqRT0YMeta } from "/app/apps/admin/pages/products/item-prototypes/items/[item].vue?macro=true";
import { default as create1ByBQZu20TMeta } from "/app/apps/admin/pages/products/item-prototypes/items/create.vue?macro=true";
import { default as editweSbsRchFVMeta } from "/app/apps/admin/pages/products/item-prototypes/items/edit.vue?macro=true";
import { default as item_45prototypes7Tv3hU3OJqMeta } from "/app/apps/admin/pages/products/item-prototypes.vue?macro=true";
import { default as _91tag_93JAGlm1rLfcMeta } from "/app/apps/admin/pages/products/tags/[tag].vue?macro=true";
import { default as create5dDFhdT8xDMeta } from "/app/apps/admin/pages/products/tags/create.vue?macro=true";
import { default as tagsGMRlpz8s5MMeta } from "/app/apps/admin/pages/products/tags.vue?macro=true";
import { default as productsc0nQFiquXDMeta } from "/app/apps/admin/pages/products.vue?macro=true";
import { default as register6WnXfGHGheMeta } from "/app/apps/admin/pages/register.vue?macro=true";
import { default as searchsxjHU2eiz0Meta } from "/app/apps/admin/pages/search.vue?macro=true";
import { default as indexoP6fdJXhPvMeta } from "/app/apps/admin/pages/settings/index.vue?macro=true";
import { default as _91user_93ClCPpp0gSAMeta } from "/app/apps/admin/pages/settings/team/[user].vue?macro=true";
import { default as indexI16NCF9HO8Meta } from "/app/apps/admin/pages/settings/team/index.vue?macro=true";
import { default as _91shipping_93vKZhXLSwnQMeta } from "/app/apps/admin/pages/shippings/[shipping].vue?macro=true";
import { default as _91history_93CXzN2V8v3GMeta } from "/app/apps/admin/pages/shippings/shipping-history/[history].vue?macro=true";
export default [
  {
    name: "components",
    path: "/components",
    meta: componentsywbQkkrTCfMeta || {},
    component: () => import("/app/apps/admin/pages/components.vue").then(m => m.default || m),
    children: [
  {
    name: "components-colors",
    path: "colors",
    component: () => import("/app/apps/admin/pages/components/colors.vue").then(m => m.default || m),
    children: [
  {
    name: "components-colors-color",
    path: ":color()",
    component: () => import("/app/apps/admin/pages/components/colors/[color].vue").then(m => m.default || m)
  },
  {
    name: "components-colors-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/components/colors/create.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "components-kinds",
    path: "kinds",
    component: () => import("/app/apps/admin/pages/components/kinds.vue").then(m => m.default || m),
    children: [
  {
    name: "components-kinds-kind",
    path: ":kind()",
    component: () => import("/app/apps/admin/pages/components/kinds/[kind].vue").then(m => m.default || m)
  },
  {
    name: "components-kinds-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/components/kinds/create.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "components-materials",
    path: "materials",
    component: () => import("/app/apps/admin/pages/components/materials.vue").then(m => m.default || m),
    children: [
  {
    name: "components-materials-material",
    path: ":material()",
    component: () => import("/app/apps/admin/pages/components/materials/[material].vue").then(m => m.default || m)
  },
  {
    name: "components-materials-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/components/materials/create.vue").then(m => m.default || m)
  },
  {
    name: "components-materials-edit-material",
    path: "edit/:material()",
    component: () => import("/app/apps/admin/pages/components/materials/edit/[material].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "components-sizes",
    path: "sizes",
    component: () => import("/app/apps/admin/pages/components/sizes.vue").then(m => m.default || m),
    children: [
  {
    name: "components-sizes-size",
    path: ":size()",
    component: () => import("/app/apps/admin/pages/components/sizes/[size].vue").then(m => m.default || m)
  },
  {
    name: "components-sizes-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/components/sizes/create.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "customers-customer",
    path: "/customers/:customer()",
    component: () => import("/app/apps/admin/pages/customers/[customer].vue").then(m => m.default || m)
  },
  {
    name: "customers-customer-history-history",
    path: "/customers/customer-history/:history()",
    component: () => import("/app/apps/admin/pages/customers/customer-history/[history].vue").then(m => m.default || m)
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/app/apps/admin/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/admin/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginpEnoFbBpCzMeta || {},
    component: () => import("/app/apps/admin/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "orders-order",
    path: "/orders/:order()",
    component: () => import("/app/apps/admin/pages/orders/[order].vue").then(m => m.default || m)
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/app/apps/admin/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "payments-payment",
    path: "/payments/:payment()",
    component: () => import("/app/apps/admin/pages/payments/[payment].vue").then(m => m.default || m)
  },
  {
    name: "payments-payment-history-history",
    path: "/payments/payment-history/:history()",
    component: () => import("/app/apps/admin/pages/payments/payment-history/[history].vue").then(m => m.default || m)
  },
  {
    name: "price-policies-policy",
    path: "/price-policies/:policy()",
    component: () => import("/app/apps/admin/pages/price-policies/[policy].vue").then(m => m.default || m)
  },
  {
    name: "price-policies-create",
    path: "/price-policies/create",
    component: () => import("/app/apps/admin/pages/price-policies/create.vue").then(m => m.default || m)
  },
  {
    name: "price-policies-edit-policy",
    path: "/price-policies/edit/:policy()",
    component: () => import("/app/apps/admin/pages/price-policies/edit/[policy].vue").then(m => m.default || m)
  },
  {
    name: "price-policies",
    path: "/price-policies",
    component: () => import("/app/apps/admin/pages/price-policies/index.vue").then(m => m.default || m)
  },
  {
    name: "products",
    path: "/products",
    meta: productsc0nQFiquXDMeta || {},
    component: () => import("/app/apps/admin/pages/products.vue").then(m => m.default || m),
    children: [
  {
    name: "products-collections",
    path: "collections",
    component: () => import("/app/apps/admin/pages/products/collections.vue").then(m => m.default || m),
    children: [
  {
    name: "products-collections-collection",
    path: ":collection()",
    component: () => import("/app/apps/admin/pages/products/collections/[collection].vue").then(m => m.default || m)
  },
  {
    name: "products-collections-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/products/collections/create.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-item-prototypes",
    path: "item-prototypes",
    component: () => import("/app/apps/admin/pages/products/item-prototypes.vue").then(m => m.default || m),
    children: [
  {
    name: "products-item-prototypes-prototype",
    path: ":prototype()",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/[prototype].vue").then(m => m.default || m)
  },
  {
    name: "products-item-prototypes-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/create.vue").then(m => m.default || m)
  },
  {
    name: "products-item-prototypes-edit-prototype",
    path: "edit/:prototype()",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/edit/[prototype].vue").then(m => m.default || m)
  },
  {
    name: "products-item-prototypes-items-item",
    path: "items/:item()",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/items/[item].vue").then(m => m.default || m)
  },
  {
    name: "products-item-prototypes-items-create",
    path: "items/create",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/items/create.vue").then(m => m.default || m)
  },
  {
    name: "products-item-prototypes-items-edit",
    path: "items/edit",
    component: () => import("/app/apps/admin/pages/products/item-prototypes/items/edit.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-tags",
    path: "tags",
    component: () => import("/app/apps/admin/pages/products/tags.vue").then(m => m.default || m),
    children: [
  {
    name: "products-tags-tag",
    path: ":tag()",
    component: () => import("/app/apps/admin/pages/products/tags/[tag].vue").then(m => m.default || m)
  },
  {
    name: "products-tags-create",
    path: "create",
    component: () => import("/app/apps/admin/pages/products/tags/create.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "register",
    path: "/register",
    meta: register6WnXfGHGheMeta || {},
    component: () => import("/app/apps/admin/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/search",
    meta: searchsxjHU2eiz0Meta || {},
    component: () => import("/app/apps/admin/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/apps/admin/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-team-user",
    path: "/settings/team/:user()",
    component: () => import("/app/apps/admin/pages/settings/team/[user].vue").then(m => m.default || m)
  },
  {
    name: "settings-team",
    path: "/settings/team",
    component: () => import("/app/apps/admin/pages/settings/team/index.vue").then(m => m.default || m)
  },
  {
    name: "shippings-shipping",
    path: "/shippings/:shipping()",
    component: () => import("/app/apps/admin/pages/shippings/[shipping].vue").then(m => m.default || m)
  },
  {
    name: "shippings-shipping-history-history",
    path: "/shippings/shipping-history/:history()",
    component: () => import("/app/apps/admin/pages/shippings/shipping-history/[history].vue").then(m => m.default || m)
  }
]